import '../css/style.scss'
import './components'
import 'wildlabs-frontend-core/js/toggleClass'
import 'wildlabs-frontend-core/js/modal'
import 'wildlabs-frontend-core/js/tabs'
import 'wildlabs-frontend-core/js/accordion'
import 'wildlabs-frontend-core/js/utils'

new ResizeObserver(() => {
  let vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}).observe(document.documentElement);
